import { useMemo } from "react";

export function Statement({ statement, onAnswer }) {
  const sortedOptions = useMemo(
    () => statement.opinionOptions.sort((a, b) => a.order - b.order),
    [statement],
  );

  function handleSubmit(event) {
    event.preventDefault();
    const value = event.nativeEvent.submitter.value;
    onAnswer(statement._id, value);
  }

  return (
    <form className="statement" onSubmit={handleSubmit}>
      <h1 className="statement__title">{statement.description}</h1>

      <div className="statement__options">
        {sortedOptions.map((option) => (
          <button
            className="statement__option button"
            key={option.opinion}
            name="statement[opinion]"
            value={option.opinion}
            style={{ "--opinion-color": option.color }}
          >
            {option.opinion}
          </button>
        ))}
      </div>
    </form>
  );
}
